export const getBiEvid = (biEvent: { evid: string }) => biEvent.evid;
